import React from "react";

import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

import "../assets/style/home.css";

import MentorImage from "../assets/images/mentor.jpeg";
import { Link } from "react-router-dom";

const Introduction = () => (
	<header>
		<h1>Welcome to nofapguidance</h1>
		<p>Quit porn and take back control of your life!</p>
		<div>
			<Link to="/pricing">Packages</Link>
			<Link to="/reviews">Reviews</Link>
		</div>
	</header>
);

const Mentor = () => (
	<section id="home-mentor">
		<div>
			<img src={MentorImage} alt="Younis Bilal" />
		</div>
		<div>
			<h1>Younis Bilal</h1>
			<h2>Founder & Mentor</h2>
			<p>"It is health that is the real wealth, and not pieces of gold and silver." - Ghandi</p>
		</div>
	</section>
);
const SupportUs = () => (
	<section id="home-support">
		<h1>We can't do it alone!</h1>
		<p>Seriously, we can't! We need your help.</p>
		<div>
			<Link to="/donate-a-program">Donate a Program</Link>
			<Link to="/support-us">Support Us</Link>
		</div>
	</section>
);

const HomePage = () => (
	<>
		<Navbar />
		<Introduction />
		<Mentor />
		<SupportUs />
		<Footer />
	</>
);

export default HomePage;